import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (d203/models/models.go)
// ============================================================

export interface FD130 {
  fd130_01: string;       // 託工單號 (PK)
  fd130_10: string;       // S/C NO
  fd130_101: number;      // S/C 項次
  fd130_11: string | null; // 託工日期
  fd130_12: string;       // 加工廠代號
  fd130_13: string | null; // 預定交期
  fd130_14: number;       // 縮率%
  fd130_141: number;      // 縮率備用
  fd130_15: string;       // 工繳代號
  fd130_16a: string;      // 包裝代號
  fd130_16b: string;      // 包裝說明
  fd130_17: string;       // 部門代號
  fd130_181: string;      // 備用代號1
  fd130_182: string;      // 備用代號2
  fd130_19: string;       // 單位
  fd130_20: string;       // 備用旗標1
  fd130_21: string;       // 備用旗標2
  fd130_22: string;       // 備註(memo)
  fd130_23: number;       // 備用數值1
  fd130_24: number;       // 備用整數1
  fd130_25: number;       // 備用整數2
  fd130_26: string;       // 結案狀態 (N/P)
  fd130_27: string;       // QC人員
  fd130_28: string;       // 備用代號3
  fd130_29: number;       // 備用數值2
  fd130_30: string;       // 備用旗標3
  fd130_31: number;       // 原料/半成品/成品
  fd130_311: boolean;     // 備用布林
  fd130_32: string;       // 備註2(memo)
  fd130_33: string;       // 建檔人員
  fd130_34: number;       // 工繳合計金額
  fd130_35: string;       // 備用代號4
  fd130_36: string;       // 備用字串
  fd130_37: number;       // 有效旗標 (1=有效)
  fd130_38: string | null; // 備用日期
  fd130_39: string;       // S/C品號
  fd130_40: number;       // 計價方式 (1=計量,2=計缸)
  fd130_41: string;       // 備註3(memo)
  fd130_411: string;      // 備註代號
  fd130_42: number;       // 色號明細項數
  fd130_43: number;       // 組織比例項數
  fd130_44: number;       // 檢驗規範項數
  fd130_45: string;       // 幣別
  fd130_46: number;       // 匯率
  fd130_47: string;       // 交易條件
  fd130_471: string;      // 付款條件
  fd130_48: number;       // 加工類別 (1=織造,2=染整,3=防水透濕)
  fd130_49: string | null; // 備用日期2
  fd130_50: number;       // 織造碼數
  fd130_51: boolean;      // 備用布林2
  fd130_52: boolean;      // 開立三聯式發票
  fd130_53: string;       // 區域碼
  fd130_61: string;       // 染色代號
  fd130_62: string;       // 定型主代號
  fd130_621: string;      // 定型子代號1
  fd130_622: string;      // 定型子代號2
  fd130_623: string;      // 定型子代號3
  fd130_624: string;      // 定型子代號4
  fd130_63: string;       // 印染代號
  fd130_64: string;       // 針織加工代號
  fd130_641: string;      // 針織加工子代號1
  fd130_642: string;      // 針織加工子代號2
  fd130_643: string;      // 針織加工子代號3
  fd130_644: string;      // 針織加工子代號4
  fd130_65: string;       // 其它代號
  fd130_651: string;      // 其它子代號1
  fd130_652: string;      // 其它子代號2
  fd130_653: string;      // 其它子代號3
  fd130_654: string;      // 其它子代號4
  fd130_70: number;       // 防水透濕備用
  fd130_71: string;       // 塗佈代號
  fd130_72: string;       // 貼合一代號
  fd130_73: string;       // 貼合二代號
  fd130_74: string;       // 貼合三代號
  fd130_75: number;       // 防水度旗標
  fd130_76: number;       // 防水度值
  fd130_77: number;       // 防水透濕備用2
  fd130_80: string;       // 核准狀態 (N/S/P/R)
  fd130_81: string;       // 備用旗標4
  fd130_82: string;       // 核准人員
  fd130_90: number;       // 版次
  fd130_91: string;       // 建檔人員(審計)
  fd130_92: string | null; // 修改日期
  fd130_93: string;       // 修改時間
  fd130_94: string;       // 刪除旗標
  fd130_491: number;      // 備用整數3
  fd130_78: string;       // 備用代號5
  fd130_79: string;       // 備用旗標5
  fd130_83: string;       // 備用旗標6

  // Associations
  details?: FD131[];
  product_desc?: FD132;
  compositions?: FD133[];
  accessories?: FD135[];
  inspections?: FD136[];
}

export interface FD131 {
  fd131_01: string;   // 託工單號 (FK)
  fd131_02: number;   // 項次
  fd131_11: string;   // 色號
  fd131_11a: string;  // 色號備用
  fd131_12: string;   // 色號名稱
  fd131_13: number;   // 成品量
  fd131_14: number;   // 指染數
  fd131_15: number;   // 備用數值
  fd131_16: number;   // 工繳單價
  fd131_161: number;  // 備用單價
  fd131_17: number;   // S/C項次
  fd131_18: string;   // S/C NO
  fd131_19: string;   // 印花配色
  fd131_20: string;   // 色卡號碼
  fd131_21: string;   // 打色通知單號
  fd131_22: string;   // 顏色類別
  fd131_23: string;   // 顏色號碼
  fd131_24: number;   // 允收量
  fd131_241: number;  // 允收比率+
  fd131_242: number;  // 允收增加量+
  fd131_243: number;  // 允收比率-
  fd131_244: number;  // 允收增加量-
  fd131_25: number;   // 工繳小計
  fd131_251: number;  // 備用小計
  fd131_90: number;   // 版次
  fd131_26: number;   // 一缸工繳
  fd131_261: number;  // 備用工繳
  fd131_27: number;   // 客戶實際需求量
  fd131_28: number;   // 備用整數
  fd131_291: string;  // 備用代號1
  fd131_292: string;  // 備用代號2
}

export interface FD132 {
  fd132_01: string;   // 託工單號 (FK)
  fd132_11: string;   // 備用(memo)
  fd132_12: string;   // 備用(memo)
  fd132_13: string;   // 產品大代號
  fd132_14: string;   // 產品子代號
  fd132_15: string;   // 採購人員
  fd132_16: string;   // 採購人員部門
  fd132_17: number;   // 備用整數
  fd132_21: string;
  fd132_22: string;
  fd132_23: string;
  fd132_24: string;
  fd132_25: string;
  fd132_26: string;
  fd132_27: string;
  fd132_28: string;
  fd132_31: string;   // 產品名稱
  fd132_32: string;   // 產品規格
  fd132_33: string;   // 加工別
  fd132_34: number;   // 幅寬(針孔內)
  fd132_35: number;   // 幅寬(針孔外)
  fd132_36: number;   // 碼重
  fd132_37: number;   // 平方米重
  fd132_38: string;   // 品質要求代號
  fd132_39: string;   // 品質要求說明
  fd132_40: string;   // 驗貨方式代號
  fd132_90: number;   // 版次
}

export interface FD133 {
  fd133_01: string;   // 託工單號 (FK)
  fd133_02: number;   // 項次
  fd133_12: number;   // 組織比例%
  fd133_90: number;   // 版次
}

export interface FD135 {
  fd135_01: string;   // 託工單號 (FK)
  fd135_02: number;   // 項次
  fd135_11: string;   // 材料代號
  fd135_12: number;   // 備用整數
}

export interface FD136 {
  fd136_01: string;   // 託工單號 (FK)
  fd136_02: number;   // 項次
  fd136_11: string;   // 測試項目代號
  fd136_12: string;   // 檢驗規範代號
  fd136_13: string;   // 檢驗類別
  fd136_90: number;   // 版次
  fd136_91: string;   // 修改人員
  fd136_92: string | null; // 修改日期
  fd136_93: string;   // 修改時間
}

// ============================================================
// Request / Response types
// ============================================================

export interface D203ListResponse {
  data: FD130[];
  total: number;
  page: number;
  size: number;
}

export interface D203CreateRequest {
  master: Partial<FD130>;
  details: Partial<FD131>[];
  product_desc: Partial<FD132>;
  compositions: Partial<FD133>[];
  accessories: Partial<FD135>[];
  inspections: Partial<FD136>[];
}

export interface D203UpdateRequest {
  master: Partial<FD130>;
  details: Partial<FD131>[];
  product_desc: Partial<FD132>;
  compositions: Partial<FD133>[];
  accessories: Partial<FD135>[];
  inspections: Partial<FD136>[];
}

// ============================================================
// Approval types
// ============================================================

export interface ApprovalResponse {
  order_no: string;
  action: string;
  old_status: string;
  new_status: string;
  message: string;
}

export interface ApprovalHistory {
  id: number;
  order_no: string;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}

// ============================================================
// API methods
// ============================================================

export const d203Api = {
  async list(page = 1, size = 20): Promise<D203ListResponse> {
    const res = await apiClient.get('/api/d203', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FD130> {
    const res = await apiClient.get(`/api/d203/${encodeURIComponent(id)}`);
    return res.data;
  },

  async previewSCInspections(scNo: string, lineSeq: number): Promise<FD136[]> {
    const res = await apiClient.get(`/api/d203/from-sc/${encodeURIComponent(scNo)}/${lineSeq}/inspections`);
    return res.data.inspections || [];
  },

  async create(data: D203CreateRequest): Promise<FD130> {
    const res = await apiClient.post('/api/d203', data);
    return res.data;
  },

  async update(id: string, data: D203UpdateRequest): Promise<FD130> {
    const res = await apiClient.put(`/api/d203/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/d203/${encodeURIComponent(id)}`);
  },

  // ============================================================
  // Approval workflow
  // ============================================================

  async submitForApproval(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d203/${encodeURIComponent(id)}/submit`, { comment: comment || '' });
    return res.data;
  },

  async approve(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d203/${encodeURIComponent(id)}/approve`, { comment: comment || '' });
    return res.data;
  },

  async reject(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d203/${encodeURIComponent(id)}/reject`, { comment: comment || '' });
    return res.data;
  },

  async writeoff(id: string, comment?: string): Promise<ApprovalResponse> {
    const res = await apiClient.post(`/api/d203/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  async getApprovalHistory(id: string): Promise<ApprovalHistory[]> {
    const res = await apiClient.get(`/api/d203/${encodeURIComponent(id)}/approval-history`);
    return res.data.data || [];
  },

  // Lookup: get display name for a reference table code
  // Uses the shared lookup API
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
